export const FETCH_APPLICATION_LIST_REQUEST = 'FETCH_APPLICATION_LIST_REQUEST';
export const FETCH_APPLICATION_LIST_SUCCESS = 'FETCH_APPLICATION_LIST_SUCCESS';

export const FETCH_APPLICATION_LIST_CONSTANTS_REQUEST = 'FETCH_APPLICATION_LIST_CONSTANTS_REQUEST';
export const FETCH_APPLICATION_LIST_CONSTANTS_SUCCESS = 'FETCH_APPLICATION_LIST_CONSTANTS_SUCCESS';

export const FETCH_REGIONS_BY_NAME_REQUEST = 'FETCH_REGIONS_BY_NAME_REQUEST';
export const FETCH_REGIONS_BY_NAME_SUCCESS = 'FETCH_REGIONS_BY_NAME_SUCCESS';

export const fetchApplicationListRequest = filterConfig => ({
  type: FETCH_APPLICATION_LIST_REQUEST,
  payload: { filterConfig },
});

export const fetchApplicationListSuccess = applciationList => ({
  type: FETCH_APPLICATION_LIST_SUCCESS,
  payload: { ...applciationList },
});

export const fetchConstantsRequest = () => ({
  type: FETCH_APPLICATION_LIST_CONSTANTS_REQUEST,
  payload: null,
});

export const fetchConstantsSuccess = constants => ({
  type: FETCH_APPLICATION_LIST_CONSTANTS_SUCCESS,
  payload: { ...constants },
});

export const fetchRegionsByNameRequest = regionName => ({
  type: FETCH_REGIONS_BY_NAME_REQUEST,
  payload: { regionName },
});

export const fetchRegionsByNameSuccess = programRegion => ({
  type: FETCH_REGIONS_BY_NAME_SUCCESS,
  payload: { ...programRegion },
});
